module.exports = __webpack_public_path__ + "img/26.e4b1ba18.jpg";